// Aviso «Llegó recomendado» en una línea: quién lo recomendó y lo que gana el cliente (nunca el que recomienda).
// Solo sale si la evaluación de la venta trae `referredBy`; si viene null no se pinta nada.
import { UserPlus } from 'lucide-react';
import { referralRewardText } from '@/domains/retail/admin/promotions/lib/referralPromotionText';
import { useSalePromotionEvaluation } from '../api/useWizardPromotions';
import { REFERRED_BY_NOTICE_LABEL as LABEL } from '../constants';

const lowerFirst = (text: string): string =>
    text.charAt(0).toLocaleLowerCase('es-MX') + text.slice(1);

export function ReferredByNotice({
    sessionId,
    customerName,
}: {
    sessionId: string;
    customerName: string;
}) {
    const referredBy = useSalePromotionEvaluation(sessionId).data?.referredBy;
    if (!referredBy) return null;
    const rewards = [...(referredBy.rewards ?? [])].sort((a, b) =>
        a.promotionName.localeCompare(b.promotionName, 'es-MX'),
    );
    return (
        <section
            aria-label={LABEL}
            className="mb-3 flex min-w-0 flex-wrap items-center gap-x-2 gap-y-1 rounded-md border border-promo-soft-border bg-promo-soft px-3 py-1.5 text-[12px] text-promo"
        >
            <span className="flex flex-none items-center gap-1.5 text-[11px] font-bold uppercase tracking-[0.06em]">
                <UserPlus className="size-3.5" aria-hidden />
                {LABEL}
            </span>
            <Dot />
            <span className="text-muted-foreground">por {referredBy.name}</span>
            {rewards.map((r) => (
                <span
                    key={r.promotionId}
                    className="flex items-center gap-2"
                    title={`Promo «${r.promotionName}»`}
                >
                    <Dot />
                    <span>
                        <b>{customerName}</b> gana {lowerFirst(referralRewardText(r.reward))}
                    </span>
                </span>
            ))}
        </section>
    );
}

/** Separador; con espacios para que el texto se lea corrido fuera de la vista. */
function Dot() {
    return <span className="text-muted-foreground">{' · '}</span>;
}
